type Params =
	| { src: string; defer?: boolean; onLoadCallback?: () => void; onErrorCallback?: () => void }
	| { inlineCode: string; onLoadCallback?: () => void; onErrorCallback?: () => void }

/**
 * Generate a script element
 * @param params Related options
 * @param params.src Script src to set
 * @param params.defer Should script execution be defered or not
 * @param params.inlineCode Inline code to set
 * @param params.onLoadCallback Callback
 * @param params.onErrorCallback Callback
 * @returns Script element
 */
export default function generateScriptElement(params: Params): HTMLScriptElement {
	const script = document.createElement('script')

	if (params.onLoadCallback) {
		script.onload = params.onLoadCallback
	}

	if (params.onErrorCallback) {
		script.onerror = params.onErrorCallback
	}

	if ('src' in params) {
		script.src = params.src
		script.defer = params.defer ?? true
	} else if ('inlineCode' in params) {
		script.innerHTML = params.inlineCode
	} else {
		throw new Error('generateScriptElement::requires either "src" or "inlineCode" parameter')
	}

	return script
}
